/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export const QuantityChip = ({ label }: { label: string }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: '4px',
        background: theme.colors.primary100,
        paddingX: '8px',
      }}
    >
      <Typography
        fontFamily='Nunito Sans'
        fontSize='16px'
        fontStyle='normal'
        fontWeight='400'
        lineHeight='150%'
        color={theme.colors.primary500}
      >
        {label}
      </Typography>
    </Box>
  );
};
